import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'superiorSubmission';

const mapStateToProps = (state, ownProps) => {
	let superiorSubmissions;
	let superiorSubmission;
	let superiorSubmissionId;

	if (state.lists.superiorSubmissionIds) {
		superiorSubmissions = _.map(
			state.lists.superiorSubmissionIds,
			(id) => state.maps.superiorSubmission[id]
		);
	}

	if (ownProps.superiorSubmission) {
		superiorSubmission = ownProps.superiorSubmission;
	} else {
		superiorSubmissionId = ownProps.superiorSubmissionId
			? ownProps.superiorSubmissionId
			: _.get(ownProps, ['match', 'params', 'superiorSubmissionId']);
		superiorSubmission = _.get(state.maps, ['superiorSubmission', superiorSubmissionId]);
	}

	return {
		superiorSubmission,
		superiorSubmissions,
		authUser: state.auth.authUser,
		resourceMap: state.maps.resource,
	};
};

const search = (p = {}) => {
	const { afterDateTime, submissionType, externalKey, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
				submissionType,
				externalKey,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getSuperiorSubmission: get,
			superiorSubmissionSearch: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
